






























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import type { Company } from '@/models/company';
import { companyWebservice } from '@/webservices/company';
import { VueCropperMethods } from '@/types/Cropper';

@Component({
    name: 'AdminUpdateCompany',
    components: {},
})
export default class AdminUpdateCompany extends Vue {
    private file: File | null = null;

    // Data
    private disabled: boolean = false;
    private isLoading: boolean = false;
    private errorMsg: string = '';

    private company: Company = {} as Company;
    private imgSrc: string = '';

    private loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    @Getter('account/company') private companyData: Company;

    @Watch('file')
    private onFileChange() {
        let reader: any;
        reader = new FileReader();
        reader.onload = (imgsrc: any) => {
            if (imgsrc.target != null) {
                const el: HTMLImageElement = document.getElementById('selectedLogo') as HTMLImageElement;
                if (el) {
                    el.src = imgsrc.target.result;
                }
            }
        };
        if (this.file !== null && this.file.size > 0 && this.file.size <= 20971520) {
            reader.readAsDataURL(this.file);
            this.errorMsg = '';
        } else if (this.file !== null && this.file.size > 20971520) {
            this.errorMsg = 'fileTooBig';
            this.file = null;
        }
    }

    private mounted() {
        this.load();
    }

    private setImage(e: InputEvent) {
        const fileInput = e.target as HTMLInputElement;

        if (!fileInput.files || fileInput.files.length === 0) {
            this.$buefy.toast.open({
                duration: 5000,
                message: this.$t('toastMessages.error.error').toString(),
                type: 'is-warning',
            });
            return;
        }
        const file = fileInput.files[0];

        if (file.type.indexOf('image/') === -1) {
            this.$buefy.toast.open({
                duration: 5000,
                message: this.$t('toastMessages.error.error').toString(),
                type: 'is-warning',
            });
            return;
        }

        const reader = new FileReader();

        reader.onload = (event) => {
            if (!event || !event.target || !event.target.result || event.target.result instanceof ArrayBuffer) {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: this.$t('toastMessages.error.error').toString(),
                    type: 'is-warning',
                });
                return;
            }
            this.imgSrc = event.target.result;
            if (this.$refs.input) {
                (this.$refs.input as HTMLInputElement).value = '';
            }
            this.file = null;
        };

        reader.readAsDataURL(file);
    }

    private selectCrop() {
        ((this.$refs.cropper as unknown) as VueCropperMethods).getCroppedCanvas().toBlob((blob) => {
            if (!blob) {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: this.$t('toastMessages.error.error').toString(),
                    type: 'is-warning',
                });
            } else {
                this.file = new File([blob], 'logo.png', { type: 'image/png' });
                this.imgSrc = '';
            }
        });
    }

    private showFileSelector() {
        if (!this.$refs.input) {
            this.$buefy.toast.open({
                duration: 5000,
                message: this.$t('toastMessages.error.error').toString(),
                type: 'is-warning',
            });
        } else {
            (this.$refs.input as HTMLInputElement).click();
        }
    }

    private clearFile() {
        this.imgSrc = '';
    }

    private async load() {
        this.isLoading = true;
        companyWebservice.getCompanyByUser().then((res) => {
            this.company = res.data;
            this.isLoading = false;
        });
    }

    private reload() {
        location.reload();
    }

    private save() {
        this.disabled = true;
        if (!this.validate() || !this.validateLogo()) {
            this.disabled = false;
            return false;
        }
        companyWebservice
            .updateByAdmin(this.company)
            .then(async (response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: 'Successfully Updated',
                    type: 'is-success',
                });
                if (this.file === null && this.company.logo_path === '' && this.companyData.logo_path) {
                    await companyWebservice.deleteLogo();
                    this.reload();
                } else if (this.file != null) {
                    await this.updateLogo(this.file);
                    this.reload();
                } else {
                    this.reload();
                    this.disabled = false;
                }
            })
            .catch((error) => {
                this.disabled = false;
                console.log(error);
            });
    }

    private async updateLogo(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        await companyWebservice.uploadLogo(formData);
    }

    private async deleteLogo() {
        this.company.logo_path = '';
    }

    private validateLogo() {
        if (this.file != null && this.file.size > 3145728) {
            this.errorMsg = 'fileTooBig';
        } else {
            return true;
        }
    }

    private validate() {
        if (!this.company.name || this.company.name === '') {
            this.errorMsg = 'name';
            return false;
        } else if (!this.company.address || this.company.address === '') {
            this.errorMsg = 'address';
            return false;
        } else if (!this.company.postcode || this.company.postcode === '') {
            this.errorMsg = 'postcode';
            return false;
        } else if (!this.company.city || this.company.city === '') {
            this.errorMsg = 'city';
            return false;
        } else if (!this.company.phone || this.company.phone === '') {
            this.errorMsg = 'phone';
            return false;
        } else if (!this.company.setting.x_en_tab_title || this.company.setting.x_en_tab_title === '') {
            this.errorMsg = 'x_en_tab_title';
            return false;
        } else if (!this.company.setting.x_de_tab_title || this.company.setting.x_de_tab_title === '') {
            this.errorMsg = 'x_de_tab_title';
            return false;
        } else if (!this.company.setting.x_en_lesson_title || this.company.setting.x_en_lesson_title === '') {
            this.errorMsg = 'x_en_lesson_title';
            return false;
        } else if (!this.company.setting.x_de_lesson_title || this.company.setting.x_de_lesson_title === '') {
            this.errorMsg = 'x_de_lesson_title';
            return false;
        } else if (!this.company.setting.x_en_process_title || this.company.setting.x_en_process_title === '') {
            this.errorMsg = 'x_en_process_title';
            return false;
        } else if (!this.company.setting.x_de_process_title || this.company.setting.x_de_process_title === '') {
            this.errorMsg = 'x_de_process_title';
            return false;
        } else if (!this.company.setting.x_en_sub_process_title || this.company.setting.x_en_sub_process_title === '') {
            this.errorMsg = 'x_en_sub_process_title';
            return false;
        } else if (!this.company.setting.x_de_sub_process_title || this.company.setting.x_de_sub_process_title === '') {
            this.errorMsg = 'x_de_sub_process_title';
            return false;
        } else {
            return true;
        }
    }
}
